import React  from "react";
import useWebsiteSetting  from "../FetchAPI";

export default function About() {
    const [webSetting] = useWebsiteSetting();

  return (
    <>

<section className="about-section py-5">
    <div className="container">
        <div className="section-header text-center mb-5">
            <span className="section-badge">
               India's Trusted Gazette Service
            </span>
            <h2 className="section-title" data-title="ABOUT">
                {webSetting.about_title}
            </h2>
            <div className="title-divider"></div>
        </div>
        <div className="row align-items-center">
            <div className="col-lg-6 mb-4 mb-lg-0">
                <div className="about-img-box">
                    <img
                        src={webSetting.about_img}
                        alt="About Rajasthan Gazette"
                        className="about-img"
                    />
                </div>
            </div>
            <div className="col-lg-6">
                <div className="about-content">
                    <span className="content-tag">
                        {webSetting.about_tagline}
                    </span>
                     <p
                  className="about_desc"
                  dangerouslySetInnerHTML={{
                    __html: webSetting.about_desc,
                  }}
                ></p>

        
                    <a href="/" className="about-btn">
                        {webSetting.about_btn_name}
                    </a>

                </div>


            </div>
                       <div className="about-features mt-5">

                        <div className="feature-item">
                            ✓ Fast Processing
                        </div>

                        <div className="feature-item">
                            ✓ Expert Guidance
                        </div>

                        <div className="feature-item">
                            ✓ Secure Documents
                        </div>

                        <div className="feature-item">
                            ✓ Trusted Service
                        </div>

                    </div>

        </div>

    </div>
</section>


      
    </>
  );
}
